const stickyMenu = document.querySelector('.menu-sticky')

const stickyMenuOffset = stickyMenu.offsetTop
const stickMenu = () => {
	console.log('scrolling')
	if (window.scrollY >= stickyMenuOffset) {
		stickyMenu.classList.add('!fixed', 'bg-menuSticky', '!max-w-[1920px]', 'sticked', 'px-5', 'py-2')
	} else {
		stickyMenu.classList.remove('!fixed', 'bg-menuSticky', '!max-w-[1920px]', 'sticked', 'px-5', 'py-2')
	}
}

document.addEventListener('scroll', stickMenu)
